// src/components/Eventos/SortableLaneRow.js
import React from 'react';
import {
  TableRow,
  TableCell,
  Typography
} from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditableNumberCell from './EditableNumberCell';

const SortableLaneRow = ({
  laneNumber,
  athlete,
  onAddAthlete,
  onReplaceAthlete,
  additionalCells,
  attributes,
  listeners,
  setNodeRef,
  style,
  cellStyle = {},         // Accept cellStyle
  buttonStyle = {},       // Accept buttonStyle
  typographyStyle = {}    // Accept typographyStyle
}) => {
  return (
    <TableRow ref={setNodeRef} style={style}>
      {/* 1) HANDLE: drag icon */}
      <TableCell
        align="center"
        sx={{ 
          cursor: athlete ? 'grab' : 'default', 
          width: 40,
          ...cellStyle  // Apply cellStyle
        }}
        {...attributes}
        {...listeners}
      >
        {athlete ? <DragIndicatorIcon /> : null}
      </TableCell>

      {/* 2) LANE NUMBER */}
      <TableCell align="center" sx={cellStyle}>
        {laneNumber}
      </TableCell>

      {/* 3) ATHLETE NUMBER OR "+" BUTTON */}
      <EditableNumberCell
        athlete={athlete}
        laneNumber={laneNumber}
        onReplaceAthlete={onReplaceAthlete}
        onAddAthlete={onAddAthlete}
        cellStyle={cellStyle}   // Pass cellStyle
        buttonStyle={buttonStyle} // Pass buttonStyle
      />

      {/* 4) NAME AND AFFILIATION */}
      <TableCell align="left" sx={cellStyle}>
        {athlete ? (
          <>
            <Typography sx={{ fontSize: typographyStyle.nameSize || 'inherit' }}>
              {athlete.fullName}
            </Typography>
            <Typography 
              variant="body2" 
              color="textSecondary"
              sx={{ fontSize: typographyStyle.teamSize || 'inherit' }}
            >
              {athlete.affiliation}
            </Typography>
          </>
        ) : (
          '-'
        )}
      </TableCell>

      {/* 5) Additional cells (results, place, actions...) */}
      {additionalCells}
    </TableRow>
  );
};

export default SortableLaneRow;